<div class="notification" (mouseenter)="showOverlay()" (mouseleave)="hideOverlay()">
    <i 
      class="fa fa-bell" 
      [ngClass]="{ 'has-notifications': notificationCount > 0 }">
    </i>
    <span class="notification-count" *ngIf="notificationCount > 0">
      {{ notificationCount }}
    </span>
    <div class="notification-overlay" [class.show]="isOverlayVisible && notifications.length">
      <div class="notification-item" *ngFor="let notification of notifications" [ngClass]="{pointer : !!notification.link}" (click)="!!notification.link && goto(notification.link)">
        <h4 [innerHTML]="notification.title"></h4>
        <p [innerHTML]="notification.content"></p>
      </div>
    </div>
  </div>